import Vue from 'vue'
import router from '@/router'
import { store } from '@/app/store'
import axios from 'axios'

export default {
  /**
   * Login.
   *
   * @param  {string} email
   * @param  {string} password
   * @return {Axios}
   */
  login(email, password) {
    let request = Vue.axios({
      method: 'post',
      url: '/oauth/token',
      data: {
        client_id: process.env.API_CLIENT_ID,
        client_secret: process.env.API_CLIENT_SECRET,
        grant_type: process.env.API_GRANT_TYPE,
        username: email,
        password: password,
      }
    })

    request.then(response => {
      // Cookie set
      window.$cookies.set(
        process.env.AUTH_COOKIE_NAME,
        response.data.token_type + ' ' + response.data.access_token,
        response.data.expires_in
      )

      // Set default axios Authorization header
      Vue.axios.defaults.headers.Authorization = window.$cookies.get(process.env.AUTH_COOKIE_NAME)

      // Redirect
      router.push(router.currentRoute.query.url
        ? { path: router.currentRoute.query.url }
        : { name: process.env.HOME_PATH_NAME }
      );
    })

    return request
  },

  register(userData) {
    const request = axios.post('/register', userData);

    request.then(response => {
      // Zapisz token
      window.$cookies.set(
        process.env.AUTH_COOKIE_NAME,
        response.data.token_type + ' ' + response.data.access_token,
        response.data.expires_in
      )

      // Ustaw nagłówek autoryzacji
      Vue.axios.defaults.headers.Authorization = window.$cookies.get(process.env.AUTH_COOKIE_NAME)

      router.push({ name: 'AuthenticationRegisterQuestions' });


    })
    return request;
  },

  /**
   * Logout.
   *
   * @param  {bool} request
   * @return {Axios}
   */
  logout(request) {
    request = typeof request != 'undefined' ? request : true;

    let logout = () => {
      // Cookie remove
      window.$cookies.remove(process.env.AUTH_COOKIE_NAME)

      // Remove default axios Authorization header
      delete Vue.axios.defaults.headers.Authorization

      // Clear stores
      store.dispatch('setUser', null)
      store.dispatch('setNotification', [])

      // Redirect
      router.push({ name: 'AuthenticationLogin' })
    }

    return new Promise((resolve, reject) => {
      if (request === true) {
        Vue.axios({
          method: 'post',
          url: '/users/logout',
        })
          .then(response => {
            resolve(response);
            logout()
          })
          .catch(error => reject(error))
      } else {
        resolve(true)
        logout()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.service.js